module.exports = __webpack_public_path__ + "static/media/thumbnail.65c83bee.jpg";